import { lazy } from 'react';

export const LogisticsPage = lazy(() => import('./LogisticsPage'));
export const LogisticsSettingsPage = lazy(() => import('./LogisticsSettingsPage'));
